module.exports = __webpack_public_path__ + "img/the_riddles_grave.651591eb.jpg";